export enum Roles {
    ADMIN = 'Admin',
    USER = 'User',
    PROCESS_MANAGER = 'Process Manager',
    DELEGATE = 'Delegate' // Not used
}
